import { ACTION_TYPE } from '../../core/redux/actionType';
import { IAppState } from '../../core/redux/IAppState';
import { Action } from 'redux';
import { assocPath } from 'ramda';


/**
 * Makes an action you can dispatch to clear out the guest hydration errors report in app state.
 */
export const clearGuestHydrationErrorReportAction = () => ({
  type: ACTION_TYPE.CLEAR_GUEST_HYDRATION_ERROR_REPORT,
});


export const clearGuestHydrationErrorReportReducer = (
  state: IAppState,
  action: Action,
): IAppState => action.type !== ACTION_TYPE.CLEAR_GUEST_HYDRATION_ERROR_REPORT ? state : assocPath(['guestHydrationErrorReport','guestHydrationErrorDetails'], [], state);